import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { bindActionCreators } from "redux";

import { Overlay } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app";

import { SecurityRolesFilter, SecurityRolesGrid, SecurityRolesActionBar } from "./components";
import { securityRolesActions } from "./SecurityRoles.actions";
import { ISecurityRolesState, ISecurityRole } from "./SecurityRoles.state";

export interface ISecurityRolesProps {
  roles: ISecurityRole[];
  selectedRole?: ISecurityRole;
  notifications: INotification[];
  isLoading: boolean;
  loadSecurityRoles: () => void;
  onSelectionChanged: (rows: ISecurityRole[]) => void;
}

export const SecurityRoles: React.FC<ISecurityRolesProps & RouteComponentProps> = ({ roles, notifications, selectedRole, isLoading, onSelectionChanged }) => {
  return (
    <>
      <Overlay show={isLoading} showSpinner />
      <Banner messages={notifications} />
      <SecurityRolesFilter />
      <SecurityRolesActionBar selectedRow={selectedRole} />
      <SecurityRolesGrid roles={roles} onSelectionChanged={onSelectionChanged} selectedRows={selectedRole ? [selectedRole] : []} />
    </>
  );
};

export default connect(
  (state: { securityRoles: ISecurityRolesState }) => {
    return {
      roles: state.securityRoles.data || [],
      notifications: state.securityRoles.notifications,
      isLoading: state.securityRoles.isLoading,
      selectedRole: state.securityRoles.selectedRole
    };
  },
  dispatch => {
    return bindActionCreators(
      {
        onSelectionChanged: securityRolesActions.onSelectionChanged
      },
      dispatch
    );
  }
)(SecurityRoles);
